// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2SPzN","rootMobile":"styles_rootMobile__3C0cQ"};